module.exports = __webpack_public_path__ + "media/images/mermaid-efb189e540019b2f9687972bc129bc05.svg";